import { useState, type FunctionComponent, type ReactNode } from 'react';

import { Button } from '@trello/nachos/button';

import * as styles from './CopyMoveCardTabs.module.less';

type Tabs = 'board' | 'inbox';

interface CopyMoveCardTabsProps {
  generateInboxTab: () => ReactNode;
  generateBoardTab: () => ReactNode;
}

export const CopyMoveCardTabs: FunctionComponent<CopyMoveCardTabsProps> = ({
  generateInboxTab,
  generateBoardTab,
}) => {
  const [activeTab, setActiveTab] = useState<Tabs>('board');

  return (
    <div>
      <Button
        className={styles.button}
        appearance={activeTab === 'inbox' ? 'default' : 'subtle'}
        onClick={() => setActiveTab('inbox')}
      >
        Inbox
      </Button>
      <Button
        className={styles.button}
        appearance={activeTab === 'board' ? 'default' : 'subtle'}
        onClick={() => setActiveTab('board')}
      >
        Board
      </Button>
      {activeTab === 'inbox' ? generateInboxTab() : generateBoardTab()}
    </div>
  );
};
